import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, TransitionGroup as _TransitionGroup } from "vue"
import _imports_0 from '../assets/coracao.webp'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = {
  key: 1,
  class: "col text-center"
}
const _hoisted_4 = { class: "mensagem animate__animated animate__bounceIn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (!_ctx.mostrar_mensagem)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.mostrarMensagem())),
                class: "col-12 col-md-6"
              }, _cache[1] || (_cache[1] = [
                _createElementVNode("img", {
                  class: "img-fluid heart",
                  src: _imports_0
                }, null, -1),
                _createElementVNode("div", { class: "heart-text" }, "Clique aqui", -1)
              ])))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_Transition, {
                  name: "bounce",
                  onBeforeEnter: _ctx.beforeEnter,
                  onEnter: _ctx.enter,
                  onLeave: _ctx.leave
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.mensagem), 1)
                  ]),
                  _: 1
                }, 8, ["onBeforeEnter", "onEnter", "onLeave"]),
                _createVNode(_TransitionGroup, {
                  name: "float-hearts",
                  tag: "div",
                  onBeforeEnter: _ctx.beforeEnterHeart,
                  onEnter: _ctx.enterHeart,
                  onLeave: _ctx.leaveHeart
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.floatingHearts, (heart, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "floating-heart",
                        style: _normalizeStyle(_ctx.getHeartStyle(heart))
                      }, null, 4))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["onBeforeEnter", "onEnter", "onLeave"])
              ]))
        ]),
        _: 1
      })
    ])
  ]))
}